import React from 'react'
import {connect} from 'react-redux'

import LabeledInput from '../../components/forms/LabeledInput'
import {reduxForm, SubmissionError} from 'redux-form'
import {AUTHENTICATION_FAILURE} from '../../constants/ActionTypes'

import {getFormLabels} from "../../selectors/Forms";
import {queryUserAuthentication} from "../../actions/UserAuthentication";
import HintWrapper from "../../components/HintWrapper";
import {delve} from "../../util/util";
import {DEVICECOOKIE_REQUIRED, INVALID_CREDENTIALS, TOTP_REQUIRED} from "../../constants/Errors";

const validate = (values, props) => {
    let errors = {}
    if (props.error === TOTP_REQUIRED) {
        if (!values.totp) {
            errors.totp = "Bitte gib den Zwei-Faktor-Authentifizierungscode an."
        }
        errors._error = TOTP_REQUIRED;
    } else if (props.error === DEVICECOOKIE_REQUIRED) {
        if (!values.totp) {
            errors.totp = "Bitte gib den Zwei-Faktor-Authentifizierungscode an."
        }
        errors._error = DEVICECOOKIE_REQUIRED;
    } else {
        if (!values.username) {
            errors.username = "Bitte gib deine Mittwald Kundennummer an."
        }
        if (values.username && values.username.match(/.+@.+/)) {
            errors.username = "Bitte gib die Kundennummer an, die du zum Anmelden im Kundencenter verwendest."
        }
        if (!values.password) {
            errors.password = "Bitte gib ein Passwort an."
        }
    }

    return errors
}

const submit = (values, dispatch, props) => {

    const validationResult = {...validate(values, props)};

    if(validationResult['_error']) {
        delete validationResult['_error'];
    }

    if (Object.keys(validationResult).length > 0) {
        return;
    }

    return dispatch(queryUserAuthentication(values.username, values.password, values.totp)).then((args) => {
        if (args && args.type === AUTHENTICATION_FAILURE) {
            if (args.status === 202 && args.error === TOTP_REQUIRED) {
                throw new SubmissionError({password: '', username: '', totp: 'Bitte gib den Zwei-Faktor-Authentifizierungscode an.', _error: TOTP_REQUIRED})
            } else if (args.status === 202 && args.error === DEVICECOOKIE_REQUIRED) {
                throw new SubmissionError({password: '', username: '', totp: 'Bitte gib den Zwei-Faktor-Authentifizierungscode an.', _error: DEVICECOOKIE_REQUIRED})
            } else if (args.status === 403 && args.error === INVALID_CREDENTIALS && (props.error === TOTP_REQUIRED || props.error === DEVICECOOKIE_REQUIRED)) {
                throw new SubmissionError({password: '', username: '', totp: 'Zwei-Faktor-Authentifizierungscode fehlerhaft', _error: TOTP_REQUIRED})
            } else {
                throw new SubmissionError({password: 'Passwort und/oder Benutzername fehlerhaft.', username: '', _error: 'Anmeldung fehlgeschlagen.'})
            }
        }
    })
}

function LoginForm(props) {

    const formLabels = getFormLabels("login");

    if (!props.existingUserAuthenticated || props.isFetchingClientData) {
        return (
            <div className="clientdata-step__login-wrapper">
                {props.usingMstudioLogin ? <HintWrapper
                    content={"Logge dich mit deinen Zugangsdaten für das Kundencenter ein. Bist du User des mStudios? Dann registriere dich bitte als Neukunde."}
                    theme={"blue"}
                /> : null}
                {props.error === TOTP_REQUIRED ? <HintWrapper content="Öffne die Zwei-Faktor App deines Geräts und bestätige hier mit dem angezeigten Code deine Identität." theme={"blue"}/> : null}
                {props.error === DEVICECOOKIE_REQUIRED ? <HintWrapper content="Um dein Gerät zu verifizieren, haben wir dem Vertragspartner eine E-Mail mit einem Verifizierungscode geschickt." theme={"blue"}/> : null}
                <form
                    disabled={props.existingUserAuthenticated}
                    onSubmit={props.handleSubmit(submit)}
                    className="clientdata-step__login-form"
                >
                    {props.error !== TOTP_REQUIRED && props.error !== DEVICECOOKIE_REQUIRED ? <LabeledInput
                        forceValidation={props.forceValidation}
                        fieldId="username"
                        label={formLabels.username}
                        placeholder="Deine Mittwald Kundennummer"
                        disabled={props.error === TOTP_REQUIRED || props.error === DEVICECOOKIE_REQUIRED}
                    /> : null}
                    {props.error !== TOTP_REQUIRED && props.error !== DEVICECOOKIE_REQUIRED ? <LabeledInput
                        forceValidation={props.forceValidation}
                        type="password"
                        fieldId="password"
                        label={formLabels.password}
                        placeholder="Dein Mittwald Passwort"
                        disabled={props.error === TOTP_REQUIRED || props.error === DEVICECOOKIE_REQUIRED}
                    /> : null}
                    {props.error === TOTP_REQUIRED ? <LabeledInput
                        fieldId="totp"
                        label={formLabels.totp}
                        placeholder="Zwei-Faktor-Authentifizierungscode"
                    /> : null}
                    {props.error === DEVICECOOKIE_REQUIRED ? <LabeledInput
                        fieldId="totp"
                        label={formLabels.devicecookie}
                        placeholder="Verifizierungscode"
                    /> : null}
                    <button
                        type="submit"
                        onClick={props.handleSubmit(submit)}
                        className={"login-form__button submit" + ((props.submitting || props.usingMstudioLogin) ? ' disabled' : '')}
                    >
                        {(props.submitting || props.isFetchingClientData) ? <span className="spinner spinner--white"></span> : "Anmelden"}
                    </button>
                </form>
            </div>
        );
    } else {
        return (
            <div className="clientdata-step__login-wrapper clientdata-step__login-wrapper--success">
                Erfolgreich als {props.clientData.firstName} {props.clientData.lastName} angemeldet!
            </div>
        );
    }

}

LoginForm.propTypes = {};


const mapStateToProps = (state, ownProps) => {
    return {
        existingUserAuthenticated: state.clientDataStep.existingUserAuthenticated,
        isFetchingClientData: state.clientDataStep.isFetchingClientData,
        clientData: state.clientDataStep.clientData,
        usingMstudioLogin: (delve(state, 'form.loginForm.values.username') || '').match(/.+@.+/)
    }
}
LoginForm = reduxForm({form: 'loginForm', destroyOnUnmount: true, validate}, mapStateToProps)(LoginForm)// eslint-disable-line
LoginForm = connect(mapStateToProps)(LoginForm)// eslint-disable-line

export default LoginForm



/** WEBPACK FOOTER **
 ** ./src/containers/clientdata/LoginForm.js
 **/